import { ILocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";
import { actionTypes } from "./hospital-list-details.actions";


export interface IHospitalDetailsList {
  hospitalDetailsList: ILocationItemResponse[];
  currentLocation: string;
  isHospitalListUpdated: boolean
}

const initialState: IHospitalDetailsList = {
  hospitalDetailsList: [],
  currentLocation: "",
  isHospitalListUpdated: false,
};

// reducer created to handle storing of getMetrolocations api response
// to restrict reduntant api calls


export const hosiptalDetailsListReducer = (
  state: IHospitalDetailsList = initialState,
  action: { type: string, payload: any },
) => {
  switch (action.type) {
  case actionTypes.SET_HOSPITAL_LIST:
    return {
      ...state,
      hospitalDetailsList: action.payload,
    };
  case actionTypes.SET_CURRENT_LOCATION:
    return {
      ...state,
      currentLocation: action.payload,
    };
  case actionTypes.SET_HOSPITAL_LIST_UPDATED:
    return {
      ...state,
      isHospitalListUpdated: action.payload,
    };
  default:
    return state;
  }
};
